// @core/api/endpoints/booking/get_available_slots.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetAvailableSlotsResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Get available slots
 * Returns available booking slots for a resource within a date range, considering existing bookings, working hours, buffer times, and booking policy constraints.
 */
export async function GetAvailableSlots(
  resource_id: string,
  params?: {
    date_from?: string | number | boolean;
    date_to?: string | number | boolean;
    duration?: string | number | boolean;
    guest_count?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetAvailableSlotsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id/slots`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<GetAvailableSlotsResponse>(requestPath, { ...requestOptions, params });
}
